import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import Layout from '../components/layout';
import Affiliations from '../components/higherEducation/affiliations';
import VideoSection from '../components/higherEducation/videoSection';
import CardsSection from '../components/higherEducation/cardsSection';
import WhyWisedoc from '../components/whyWisedoc';
import FAQSection from '../components/home/shared/faqSections';
import HeroFeature from '../components/home/shared/heroFeaturePages';
import SEO from '../components/seo';
import Testimonial from '../components/home/shared/testimonial';

const data = {
  content: {
    children: [
      {
        Key: 1,
        imgUrl: 'https://gatsby.wisedoc.net/homepage/Veteran_Expert_Tips.png',
        heading1: 'JOB DUTY GUIDE',
        subHeading1:
          'Having tips while writing can be very helpful, especially if you’re a veteran',
        text: "Wisedoc's veteran job duty tips are written by career counselors from all branches of service, each with over 20 years of experience. Access this valuable content by registering for premium access.",
        alt: 'JOB DUTY GUIDE',
      },
      {
        Key: 2,
        imgUrl:
          'https://gatsby.wisedoc.net/homepage/Veteran_Skill_Matching.png',
        heading1: 'AI RESUME REVIEW AND SKILL MATCHING',
        subHeading1:
          'Keyword dump alerts, contextual matching and many more...',
        text: "Wisedoc's AI resume review identifies the skills you gained during your service and compares them against the job description you're applying for. It then helps you optimize your resume to align with that specific role.",
        alt: 'AI RESUME REVIEW AND SKILL MATCHING',
      },
      {
        Key: 3,
        imgUrl: 'https://gatsby.wisedoc.net/homepage/Veteran_Career_Path.png',
        heading1: 'AI CAREER PATH',
        subHeading1: 'Discover your next career moves',
        text: 'Wisedoc evaluates the skills you used during your service and maps them to relevant industries to identify job roles you qualify for. You can then use this information to search for jobs on any available job board.',
        alt: 'AI CAREER PATH',
      },
      {
        Key: 4,
        imgUrl:
          'https://gatsby.wisedoc.net/homepage/Veteran_Coverletter_Generation.png',
        heading1: 'AI COVER LETTER GENERATION',
        subHeading1: 'Standard or tailored cover letter',
        text: 'Wisedoc uses AI to generate a customized cover letter for a specific job, ensuring it aligns with your resume and job responsibilities.',
        alt: 'AI COVER LETTER GENERATION',
      },
      {
        Key: 5,
        imgUrl:
          'https://gatsby.wisedoc.net/homepage/Veteran_Interview_Questions.png',
        heading1: 'AI INTERVIEW QUESTION GENERATOR',
        subHeading1: 'Get the questions recruiters actually ask',
        text: 'Wisedoc suggests interview questions along with answers you can confidently give in clear, civilian language. This helps you prepare for interviews with ease.',
        alt: 'AI INTERVIEW QUESTION GENERATOR',
      },
    ],
  },
  Headings: {
    children: [
      {
        heading1: 'Features and Benefits for Veterans',
        subHeading1:
          'Below are the features customized for veterans to support you through every step of your career preparation.',
      },
    ],
  },
};

const faqs = [
  {
    question:
      'How does Wisedoc help translate my military experience into a civilian resume?',
    answerLine:
      'Wisedoc uses AI to convert your military job titles, duties, and accomplishments into civilian-friendly language. It highlights your transferable skills so that employers can easily understand your value.',
  },
  {
    question: 'I’m not sure what type of job I qualify for—can Wisedoc help?',
    answerLine:
      'Yes. Wisedoc analyzes the skills you used during service and maps them to relevant job roles in the civilian workforce. You’ll receive a list of careers that match your background, making job targeting easier.',
  },
  {
    question: 'Does Wisedoc help with cover letters and interview preparation?',
    answerLine:
      'Absolutely. Wisedoc generates tailored cover letters for specific jobs and suggests interview questions and responses using clear, civilian language—helping you build confidence for the next step.',
  },
  {
    question: 'Do I need resume-writing experience to use Wisedoc?',
    answerLine:
      "No experience needed. Wisedoc provides a step-by-step guided experience, automatically formatting and optimizing your resume based on your answers. It's designed to make resume writing simple—even for first-timers.",
  },
  {
    question: 'Is Wisedoc free for veterans?',
    answerLine:
      "Veterans at partner universities can access Wisedoc for free through their school's license. If your school isn't a partner, you can access all features through a premium subscription.",
  },
];

const heroData = {
  title: 'Customized by Veterans for Veterans',
  subTitle: 'Turning military experience into civilian opportunity.',
  src: 'https://gatsby.wisedoc.net/homepage/Resume-Builder.png',
  isVideo: true,
  videoSrc: 'https://www.youtube.com/embed/tqgD6-1wBIs',
};
export const pageQuery = graphql`
  query {
    contentfulStaticPages(slug: { eq: "veterans" }) {
      id
      title
      slug
      featureImage {
        url
        description
      }
      description
    }
  }
`;
const Veterans = ({ location }) => {
  const { contentfulStaticPages: SEOdata } = useStaticQuery(pageQuery);
  return (
    <Layout location={location} title="Veterans">
      <SEO
        title={SEOdata.title}
        description={SEOdata.description}
        image={SEOdata.featureImage.url}
        pathname="veterans"
        blogURL="veterans"
      />
      <HeroFeature appType="GATSBY" data={heroData} />
      <Testimonial />
      <Affiliations />
      <VideoSection />
      {/* <WhyWisedocFeatures data={wisedocFeatures} /> */}
      <WhyWisedoc data={data} bgColor="#FCFCFF" />
      <FAQSection faqs={faqs} />
      <CardsSection />
    </Layout>
  );
};

export default Veterans;
